import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {BACKEND_KEYS, BACKEND_METHOD_CONSTANT, BACKEND_METHOD_TYPES, URL_CONSTANT} from './url-constant';

import {BaseAPI} from './baseAPI';
import {ServerModel} from '../models/server.model';
import {AuthService} from './auth.service';
import {map} from 'rxjs/operators';
import {ServerReportModel} from '../models/server-report.model';
import * as underscore from 'underscore';
import {SapModel} from '../models/sap.model';
import {ConfigLoraSendModel} from "../models/config-Lora-Send.model";


@Injectable()
export class ServersService extends BaseAPI {
  constructor(public http: HttpClient, public authService: AuthService) {
    super(http, authService);
  }

  getServerFromId(serverId: number, servers: ServerModel[]): ServerModel {
    for (const server of servers) {
      if (serverId === server.id) {
        return server;
      }
    }
    return null;
  }

  getServerDomainFromId(serverId: number, servers: ServerModel[]): string {
    const server = this.getServerFromId(serverId, servers);
    return server ? server.domain : null;
  }

  getServers(username: string = this.authService.user.username,
             password: string = this.authService.user.password): Observable<ServerModel[]> {
    const httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, username).set(BACKEND_KEYS.pass, password);

    const url = BACKEND_METHOD_CONSTANT.server + BACKEND_METHOD_TYPES.list;

    return this.get(url, httpParams).pipe(map((servers: ServerModel[]) => {
      const array = underscore.map(servers, function (server) {
        return new ServerModel(server.id, server.name, server.ip, server.domain,
          server.eventsLifetimeDays, server.deploymentStatus, server.serverType);
      });
      // console.log(regionsArray)
      return array ? array : undefined;
    }))
      .catch(this.handleError);
  }

  getServerReport(serverId): Observable<ServerReportModel[]> {
    const httpParams = this.getBaseHttpParams().set(BACKEND_KEYS.serverId, serverId.toString());

    const url = BACKEND_METHOD_CONSTANT.serverReport;

    return this.get(url, httpParams).pipe(map((objects: ServerReportModel[]) => {
      // console.log(objects);
      return objects ? objects : undefined;
    }))
      .catch(this.handleError);
  }

  getServerReportRealTime(serverId: number): Observable<SapModel[]> {
    const httpParams = this.getBaseHttpParams().set(BACKEND_KEYS.serverId, serverId.toString());

    const url = BACKEND_METHOD_CONSTANT.sapCount;

    return this.get(url, httpParams).pipe(map((objects: SapModel[]) => {
      // console.log(objects);
      return objects ? objects : undefined;
    }))
      .catch(this.handleError);
  }


  getListServerReport(): Observable<ServerReportModel[]> {
    const httpParams = this.getBaseHttpParams();

    const url = BACKEND_METHOD_CONSTANT.serverReport;

    return this.get(url, httpParams).pipe(map((objects: ServerReportModel[]) => {
      // console.log(objects);
      return objects ? objects : undefined;
    }))
      .catch(this.handleError);
  }

  getServerReportHistory(
    serverId: number,
    startTime: string,
    endTime: string,
  ): Observable<ServerReportModel[]> {
    let httpParams = this.getBaseHttpParamsWithoutPlatform();

    httpParams = httpParams.set(BACKEND_KEYS.startTime, startTime);

    httpParams = httpParams.set(BACKEND_KEYS.endTime, endTime);

    httpParams = httpParams.set(BACKEND_KEYS.serverId, String(serverId));

    const url = BACKEND_METHOD_CONSTANT.serverReportHisotry;

    return this.get(url, httpParams).pipe(map((objects: ServerReportModel[]) => {
      return objects ? objects : undefined;
    }))
      .catch(this.handleError);
  }

  getListShortReportTableSize(
    serverId: number,
    startTime: string,
    endTime: string,
  ): Observable<[]> {
    let httpParams = this.getBaseHttpParamsWithoutPlatform();

    httpParams = httpParams.set(BACKEND_KEYS.startTime, startTime);

    httpParams = httpParams.set(BACKEND_KEYS.endTime, endTime);

    httpParams = httpParams.set(BACKEND_KEYS.serverId, String(serverId));

    const url = BACKEND_METHOD_CONSTANT.listShortReportTableSize;

    return this.get(url, httpParams).pipe(map((objects: []) => {
      return objects ? objects : undefined;
    }))
      .catch(this.handleError);
  }

  getConfigLoraSendList(serverId: number): Observable<ConfigLoraSendModel> {
    let httpParams = this.getBaseHttpParamsWithoutPlatform();
    httpParams = httpParams.set(BACKEND_KEYS.module, 'STATUS_REPORTS');
    httpParams = httpParams.set(BACKEND_KEYS.serverId, String(serverId));

    const url = BACKEND_METHOD_CONSTANT.edgeColudConfiguration + BACKEND_METHOD_TYPES.list;

    return this.get(url, httpParams).pipe(map((objects: ConfigLoraSendModel) => {
      return objects ? objects : undefined;
    }))
      .catch(this.handleError);
  }
}
